import { IPageEntity, IStoryEntity } from '@/graphql/__generated__/global/types';
import { findFullSlug } from '@/lib/strapiQueries';
import { ItemListElements } from 'next-seo/lib/types';
import { getBaseUrl } from './getBaseUrl';

const baseUrl = getBaseUrl();

export const generateItemListElements = (page: IPageEntity | IStoryEntity, parentItemListElements: ItemListElements[]): ItemListElements[] => {
    let parentItemListElementsArr = [...parentItemListElements];
    const parentPage = page?.attributes?.parentPage?.data;

    if (parentPage) {
        parentItemListElementsArr = [...generateItemListElements(parentPage, parentItemListElementsArr)];
    }

    return [
        ...parentItemListElementsArr,
        {
            item: `${baseUrl}/${findFullSlug(page).join('/')}`,
            name: (page as IPageEntity)?.attributes?.title ?? (page as IStoryEntity)?.attributes?.cmsTitle ?? '',
            position: parentItemListElementsArr.length + 1,
        },
    ];
};
